import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, steps, onStepClick }) => {
  return (
    <div className="bg-white border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <div key={step?.id} className="flex items-center">
            <div 
              className={`flex items-center cursor-pointer ${
                index <= currentStep ? 'text-primary' : 'text-muted-foreground'
              }`}
              onClick={() => onStepClick(index)}
            >
              <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all ${
                index < currentStep 
                  ? 'bg-primary border-primary text-white' 
                  : index === currentStep
                  ? 'border-primary text-primary bg-white' :'border-border text-muted-foreground bg-white'
              }`}>
                {index < currentStep ? (
                  <Icon name="Check" size={16} />
                ) : (
                  <span className="text-sm font-medium">{index + 1}</span>
                )}
              </div>
              <div className="ml-3 hidden sm:block">
                <div className={`text-sm font-medium ${
                  index <= currentStep ? 'text-foreground' : 'text-muted-foreground'
                }`}>
                  {step?.title}
                </div>
                <div className="text-xs text-muted-foreground">
                  {step?.description}
                </div>
              </div>
            </div>
            {index < steps?.length - 1 && (
              <div className={`w-8 h-0.5 mx-4 ${
                index < currentStep ? 'bg-primary' : 'bg-border'
              }`} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;